module.exports = __webpack_public_path__ + "img/3.1be186c4.png";